import React from "react";
import { useTranslation } from "react-i18next";

import { HookFormCheckbox } from "../../../../HookForm/Checkbox";

export const NotifyOnAlertCheck = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`adminLocationAlertsPage.adminLocationAlertCreateModal.${key}`);

  return (
    <div className="notify-on-alert-check">
      <HookFormCheckbox
        name="notify_on_alert"
        label={t("fields.notify_on_alert.label")}
      />
    </div>
  );
};
